import { render, staticRenderFns } from "./Gradients.vue?vue&type=template&id=120222d8&scoped=true&"
var script = {}
import style0 from "./Gradients.vue?vue&type=style&index=0&id=120222d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120222d8",
  null
  
)

export default component.exports